import { render } from "./CorreosPage.vue?vue&type=template&id=60c94d0a"
import script from "./CorreosPage.vue?vue&type=script&lang=js"
export * from "./CorreosPage.vue?vue&type=script&lang=js"

import "./CorreosPage.vue?vue&type=style&index=0&id=60c94d0a&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__